import React from "react";
import PropTypes from "prop-types";
import Divider from "@mui/material/Divider";
import SFUseStyled from "../../hooks/useStyled";

const { styled } = SFUseStyled();

const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.grey300.main,
}));

const SFDivider = (props) => {
  return (
    <StyledDivider
      orientation={props.orientation}
      flexItem={props.flexItem}
      {...props}
    >
      {props.children}
    </StyledDivider>
  );
};

SFDivider.defaultProps = {
  orientation: "horizontal",
};

SFDivider.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  flexItem: PropTypes.bool,
  children: PropTypes.node,
};

export default SFDivider;
